import { useState, ReactElement, ChangeEvent} from 'react';
import { useCookies } from 'react-cookie'
import { CookieSetOptions } from 'universal-cookie'
import { LoginHeader } from '../../components/login/LoginHeader';
import { ErrorMessage } from '../../components/login/ErrorMessage';
import { UNSAFE_shouldHydrateRouteLoader, useNavigate, useSearchParams } from 'react-router-dom';
import { loginValidate, resetInputValidate } from '../../components/login/loginValidate';
import { InputField } from '../../components/login/InputField'
import { Footer } from '../../components/common/Footer';
import { useAsyncEffect } from '../../helper/hooks/async-hooks';
import { setPassResetUrl } from '../../components/login/setPassResetUrl';
import { getLoginInfo } from '../../components/login/getLoginInfo';


/**
 * ログイン画面
 */
export function Reilogspf001(){

    const navigate = useNavigate();
    //  Cookieの有効期限:　7日間
    const _7_DayBySeconds = 60 * 60 * 24 * 7;

    //  アカウントIDを保存するcookie
    const [cookieAccId, setCookieAccId, removeCookieAccId] = useCookies(['idCookie']);
    const accIdOptions: CookieSetOptions = {
        path: '/',
        maxAge: _7_DayBySeconds
    }

    //  対応会員番号を保存するcookie（秘書の場合のみ）
    const [cookieSecAccId, setCookieSecAccId, removeCookieSecAccId] = useCookies(['secIdCookie'])
    const secAccIdOptions: CookieSetOptions = {
        path: '/',
        maxAge: _7_DayBySeconds
    }

    //  メールアドレスを保存するcookie
    const [cookieMail, setCookieMail, removeCookieMail] = useCookies(['mailCookie']);
    const mailOptions: CookieSetOptions = {
        path: '/',
        maxAge: _7_DayBySeconds
    }

    //  パスワードを保存するcookie
    const [cookiePass, setCookiePass, removeCookiePass] = useCookies(['passCookie'])
    const passOptions: CookieSetOptions = {
        path: '/login',
        maxAge: _7_DayBySeconds
    }

    //  ロータリーCDを保存するcookie
    const [cookieRotaryCd, setCookieRotaryCd, removeCookieRotaryCd] = useCookies(['rotaryCookie'])
    const rotaryCdOptions: CookieSetOptions = {
        path: '/',
        maxAge: _7_DayBySeconds
    }

    // モーダルの表示状態を保持するstate
    const [isModal, setIsModal] = useState(false);

    //  メールの送信有無を保持するstate
    const [isSend, setIsSend] = useState(false)

    //  ログイン時の入力値を保持するstate
    const [loginInput, setLogininput] = useState({
        address: "",
        password: ""
    });

    //  入力した再設定用アドレスを保持するstate
    const [inputResetAddress, setInputResetAddress] = useState<string>("");

    //  エラーメッセージを保持するstate
    const[errorMsg, setErrorMsg] = useState<string[]>([]);

    //  モーダルのエラーメッセージを保持するstate
    const[modalErrMsg, setModalErrMsg] = useState<string[]>([]);


    //  inputタグへの入力をstateに保存する関数
    const inputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setLogininput({
            ...loginInput,
            [name]: [value]
        })
    }


    //  cookieに保存されている メールアドレス、パスワードがあれば設定
    useAsyncEffect(async () => {
        const loginAddress = cookieMail.mailCookie;
        const loginPass = cookiePass.passCookie;
    
        if(loginAddress || loginPass){
            setLogininput({
                address: loginAddress,
                password: loginPass
            })
        }
    },[])


    //  ログインボタン押下時の入力チェック
    const onClickLogin = async () => {
        //  入力値のエラーチェック
        const error = loginValidate(loginInput)

        if(error.length > 0){
            setErrorMsg(error);
            return;
        }

        //  登録済みユーザチェック
        const mailAddress: string = loginInput.address
        const pass: string = loginInput.password
        const accountInfo = await getLoginInfo({
            address: mailAddress[0],
            password: pass[0]
        })

        //  登録されていないユーザの場合 accountInfoは空のオブジェクト
        if(Object.keys(accountInfo).length  === 0){
            setErrorMsg(['メールアドレスまたはパスワードに誤りがあります。'])
            return
        }

        //  エラーが無ければメッセージクリア
        setErrorMsg([]);

        //  既にcookieに保存されている対応会員番号を削除
        removeCookieSecAccId("secIdCookie", secAccIdOptions);

        //  cookieにアカウントID、メールアドレス、パスワード、ロータリーCDを保存
        setCookieAccId("idCookie", accountInfo.accId, accIdOptions)
        setCookieMail("mailCookie", loginInput.address, mailOptions)
        setCookiePass("passCookie", loginInput.password, passOptions)
        setCookieRotaryCd("rotaryCookie", accountInfo.rotaryCd, rotaryCdOptions);

        //  秘書の場合のみ、対応会員番号をcookieに保存
        if(accountInfo.division === '1'){
            setCookieSecAccId("secIdCookie", accountInfo.secAccId, secAccIdOptions)
        }

        //  次の画面へ遷移
        //  マイページに遷移
        navigate('/mypage');
    }


    /**
     * パスワード再設定　送信ボタン押下時の入力チェック
     */
    const resetOnclick = async () => {
         //  入力値のエラーチェック
         const error = resetInputValidate(inputResetAddress);

         if(error.length > 0){
            setModalErrMsg(error);
            return
         }

         //  エラーが無ければメッセージクリア
        setErrorMsg([]);

        //  メール送信・DB登録・更新処理
        const response = await setPassResetUrl({
            address: inputResetAddress
        })

        //  入力されたメールアドレスがDBに登録されていなかった場合
        if(response === 400){
            setModalErrMsg(['登録しているメールアドレスを入力してください。']);
            return
        }
        setIsSend(true)

    }

    return(
        <div className="l-wrapper sp-view">
            <main className={`l-login ${isModal && "is-modal"}`} id="modal1">
                <form>
                    <div className="l-inner">
                        <LoginHeader />
                        <div className="login-wrap">
                            {/* エラーメッセージエリア */}
                            {errorMsg.length > 0 &&
                                <ErrorMessage 
                                    messages={errorMsg}
                                />
                            }

                            <div className="form-area">
                                <InputField
                                    title={'メールアドレス'}
                                    type={'text'}
                                    name={'address'}
                                    value={loginInput.address}
                                    onChange={inputChange}
                                />
                                <InputField
                                    title={'パスワード'}
                                    type={'password'}
                                    name={'password'}
                                    value={loginInput.password}
                                    onChange={inputChange}
                                />
                            </div>
                            <div className="btn-area flex-column col1">
                                <button 
                                    type="button"
                                    className="btn-main btnsz-l"
                                    onClick={() => onClickLogin()}
                                >
                                    ログイン
                                </button>
                            </div>
                            <div className="block col1">
                                <a 
                                    className="fsz-s"
                                    onClick={() => {
                                        setIsModal(true)
                                    }}>
                                        パスワードを忘れた方はこちら
                                </a>
                            </div>
                            
                            {/** モーダルエリア */}
                            <div className="overlay-box">
                                <div className="modal-box">
                                    <div className="modal-base">
                                        <div className="mdl-wrap">
                                            <div className="mdl-cont">
                                                <div className="mdl-ttl">パスワード再設定</div>
                                                <dl className="mdl-dl">
                                                    {isSend ?
                                                        <>
                                                            <dt>
                                                                ご入力いただいたメールアドレスに、パスワード再設定用メールを送信しました。
                                                            </dt>
                                                            <div className="btn-area">
                                                                <div className="flex-center is-col">
                                                                <a
                                                                    href="/login"
                                                                    className="btn-main btnsz-l"
                                                                >
                                                                    ログイン画面へ
                                                                </a>
                                                                </div>
                                                            </div>
                                                        </>


                                                    :
                                                    <>
                                                    <dt className="read">ご入力いただいたメールアドレスに、パスワード再設定用URLを送りします。</dt>

                                                    {/* モーダル用エラーメッセージエリア */}
                                                    {modalErrMsg.length > 0 &&
                                                        <ErrorMessage 
                                                            messages={modalErrMsg} />
                                                    }

                                                    <dt className="modal-mail">メールアドレス</dt>
                                                    <dl>
                                                        <dd>
                                                            <fieldset className="frm-tx-box">
                                                                <label className="frm-lb">
                                                                    <input 
                                                                        type="text" 
                                                                        className="input-modal size-modal" 
                                                                        name="PassChangeMail" 
                                                                        placeholder="human@gmail.com"
                                                                        value={inputResetAddress}
                                                                        onChange={e => {
                                                                            setInputResetAddress(e.target.value)
                                                                        }} />
                                                                </label>
                                                            </fieldset>
                                                        </dd>
                                                    </dl>
                                                    <div className="btn-area">
                                                        <div className="flex-center is-col">
                                                            <button 
                                                                type="button" 
                                                                className="btn-main btnsz-l" 
                                                                id="sendButton" 
                                                                onClick={() => {
                                                                    resetOnclick()
                                                                }}
                                                            >
                                                                    送信</button>
                                                            <button 
                                                                type="button" 
                                                                className="btn-sub btnsz-m" 
                                                                onClick={() => {
                                                                    setIsModal(false)
                                                                    setModalErrMsg([])
                                                                    setInputResetAddress('')
                                                                }}>
                                                                    キャンセル</button>
                                                        </div>
                                                    </div>
                                                    </>
                                                }
                                                </dl>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="overlay-bg"></div>
                        </div>
                    </div>
                </form>
            </main>
            <Footer />
        </div>
    );
}